export default function ShippingPolicyPage() {
  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-12 py-16" data-testid="shipping-policy-page">
      <h1 className="font-serif text-4xl font-medium text-nexa-charcoal mb-8">Shipping Policy</h1>
      <p className="text-muted-foreground mb-8">Last Updated: January 1, 2026</p>
      <div className="prose prose-lg max-w-none text-nexa-charcoal space-y-8">
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Shipping Destinations</h2>
          <p className="text-muted-foreground leading-relaxed">Nexaorbits currently ships to all 50 states within the United States, including Alaska and Hawaii. We do not currently offer international shipping.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Free Shipping</h2>
          <p className="text-muted-foreground leading-relaxed">We offer <strong>FREE standard shipping</strong> on all orders over $75 within the continental United States. Orders under $75 will incur a flat shipping fee of $9.99.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Shipping Methods and Delivery Times</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-muted-foreground">
              <thead>
                <tr className="border-b border-nexa-border">
                  <th className="text-left py-3 font-semibold text-nexa-charcoal">Shipping Method</th>
                  <th className="text-left py-3 font-semibold text-nexa-charcoal">Delivery Time</th>
                  <th className="text-left py-3 font-semibold text-nexa-charcoal">Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-nexa-border"><td className="py-3">Standard Shipping</td><td className="py-3">5-7 Business Days</td><td className="py-3">FREE (orders $75+) / $9.99</td></tr>
                <tr className="border-b border-nexa-border"><td className="py-3">Express Shipping</td><td className="py-3">2-3 Business Days</td><td className="py-3">$14.99</td></tr>
                <tr className="border-b border-nexa-border"><td className="py-3">Overnight Shipping</td><td className="py-3">1 Business Day</td><td className="py-3">$24.99</td></tr>
              </tbody>
            </table>
          </div>
          <p className="text-sm text-muted-foreground mt-4">Delivery times are estimates and do not include order processing time.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Order Processing</h2>
          <p className="text-muted-foreground leading-relaxed">All orders are processed within 1-2 business days (Monday - Friday, excluding holidays). Orders placed after 2:00 PM EST or on weekends will be processed the next business day.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Order Tracking</h2>
          <p className="text-muted-foreground leading-relaxed">Once your order ships, you will receive a confirmation email with tracking information. You can track your package using the tracking number provided.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Delivery Issues</h2>
          <p className="text-muted-foreground leading-relaxed"><strong>Lost Packages:</strong> If your package shows as delivered but you have not received it, please check with neighbors and your local post office. Contact us within 7 days.<br /><br /><strong>Damaged Packages:</strong> If your package arrives damaged, please take photos and contact us within 48 hours.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-semibold mb-4">Contact Us</h2>
          <p className="text-muted-foreground leading-relaxed"><strong>Email:</strong> support@nexaorbits.store<br /><strong>Phone:</strong> +1-888-351-1122<br /><strong>Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM EST</p>
        </section>
      </div>
    </div>
  );
}
